import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography, TextField } from "@mui/material";
import isEqual from "lodash/isEqual";
import { withStyles } from "@mui/styles";
import * as chrono from "chrono-node";
import moment from "moment";
import { convertTime12to24 } from "../../helpers/convertTime12to24";
const days = {
  mo: "Monday",
  tu: "Tuesday",
  we: "Wednesday",
  th: "Thursday",
  fr: "Friday",
  sa: "Saturday",
  su: "Sunday",
};

const formatTime = (value) => {
  if (/^[0-9]{1,2}$/.test(value)) {
    value = `${value}:00`;
  }
  const parsed = chrono.parseDate(value);
  const date = moment(parsed);
  if (date.isValid()) {
    return date.format("HH:mm");
  } else {
    return "";
  }
};

const Hours = ({ open, close, day, handleChange, classes, closed }) => (
  <div className={classes.container}>
    <Typography className={classes.heading}>
      {days[day]} {closed && <em>(closed) </em>}
    </Typography>
    <TextField
      id={`operating-hours-${day}-open`}
      type="time"
      label="Open"
      InputLabelProps={{
        shrink: true,
      }}
      value={convertTime12to24(open)}
      onChange={(e) => handleChange(day, "open", e.target.value)}
      onBlur={(e) => {
        handleChange(day, "open", formatTime(e.target.value));
      }}
      style={{ marginRight: 20 }}
    />
    <TextField
      id={`operating-hours-${day}-close`}
      label="Close"
      type="time"
      value={convertTime12to24(close)}
      InputLabelProps={{
        shrink: true,
      }}
      slotProps={{
        htmlInput: {
          step: 900, // 15 min
        },
      }}
      onChange={(e) => handleChange(day, "close", e.target.value)}
      onBlur={(e) => {
        handleChange(day, "close", formatTime(e.target.value));
      }}
    />
  </div>
);

Hours.propTypes = {
  open: PropTypes.string.isRequired,
  close: PropTypes.string.isRequired,
  day: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

class OperatingHours extends Component {
  state = {
    mo: { open: "", close: "" },
    tu: { open: "", close: "" },
    we: { open: "", close: "" },
    th: { open: "", close: "" },
    fr: { open: "", close: "" },
    sa: { open: "", close: "" },
    su: { open: "", close: "" },
  };

  componentDidMount() {
    if (this.props.hours) {
      this.setState(this.props.hours);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (isEqual(nextProps.hours, this.state)) return;
    this.setState(nextProps.hours);
  }

  handleChange = (day, when, time) => {
    this.setState(
      (prevState) => ({
        [day]: {
          ...prevState[day],
          [when]: time,
        },
      }),
      () => {
        this.props.handleChange && this.props.handleChange(this.state);
      },
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.wrapper}>
        {Object.keys(days).map((day, i) => (
          <Hours
            classes={classes}
            key={day}
            open={this.state[day].open}
            close={this.state[day].close}
            day={day}
            closed={this.state[day].open === "" || this.state[day].close === ""}
            handleChange={this.handleChange}
          />
        ))}
      </div>
    );
  }
}

const hoursShape = PropTypes.shape({
  open: PropTypes.string.isRequired,
  close: PropTypes.string.isRequired,
});

OperatingHours.propTypes = {
  hours: PropTypes.shape({
    mo: hoursShape,
    tu: hoursShape,
    we: hoursShape,
    th: hoursShape,
    fr: hoursShape,
    sa: hoursShape,
    sun: hoursShape,
  }),
  handleChange: PropTypes.func.isRequired,
};

const styles = (theme) => ({
  heading: {
    fontWeight: "bold",
  },
  container: {
    margin: theme.spacing(2),
  },
});

export default withStyles(styles)(OperatingHours);
